
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"73","height":"73","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#2B938C","d":"M0 0h73v73H0z"}}),_c('path',{attrs:{"d":"M56 58.875V54a9.75 9.75 0 00-9.75-9.75h-19.5A9.75 9.75 0 0017 54v4.875M36.5 34.5c5.385 0 9.75-4.365 9.75-9.75S41.885 15 36.5 15s-9.75 4.365-9.75 9.75 4.365 9.75 9.75 9.75z","stroke":"#fff","stroke-width":"5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    